import { render, staticRenderFns } from "./PhilhealthContributionDetails.vue?vue&type=template&id=81ce858c&scoped=true"
import script from "./PhilhealthContributionDetails.vue?vue&type=script&lang=js"
export * from "./PhilhealthContributionDetails.vue?vue&type=script&lang=js"
import style0 from "./PhilhealthContributionDetails.vue?vue&type=style&index=0&id=81ce858c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ce858c",
  null
  
)

export default component.exports